export const PULSE_SOP_STATUS_CONFIG = {
  none: {
    label: 'Yet to Draft',
    // Small text: this palette's greys are light — gray-900 is the readable secondary text.
    textColor: 'text-gray-900',
    bgColor: '',
    isBadge: false
  },
  generating: {
    label: "Drafting protocols",
    textColor: 'text-amber-700',
    bgColor: 'bg-amber-50',
    isBadge: true
  },
  draft: {
    label: "Drafts ready",
    textColor: 'text-blue-700',
    bgColor: 'bg-blue-50',
    isBadge: true
  },
  published: {
    label: "Drafts ready",
    textColor: 'text-blue-700',
    bgColor: 'bg-blue-50',
    isBadge: true
  }
} as const;

// The Ticket Categorization panel shows a single aggregate status per subcategory:
// no SOPs yet, currently drafting one, or a count of SOPs already drafted — the
// individual draft/published/approval state of each SOP lives on the SOP itself
// (see SOP_APPROVAL_STATUS_CONFIG), not here.
export function getPulseStatusLabel(status: keyof typeof PULSE_SOP_STATUS_CONFIG, sopCount: number): string {
  if (status === 'draft' || status === 'published') {
    return `${sopCount} ${PULSE_SOP_STATUS_CONFIG[status].label}`;
  }
  return PULSE_SOP_STATUS_CONFIG[status].label;
}

export const POLL_INTERVAL_MS = 10000;
